import styled from 'styled-components';
import { Box as MuiBox } from '@mui/material';

export const SDayWrapper = styled(MuiBox)`
  && {
    width: 100%;
    height: 100%;
  }
`;

export const STimeBox = styled(({ theme, ...props }) => <MuiBox {...props} />)`
  && {
    font-weight: 600;
    font-size: 8px;
    line-height: 11px;
    color: ${({ theme }) => theme.palette.colors.black100};
  }
`;
const STime = styled('div')`
  && {
    display: flex;
    justify-content: flex-start;
    font-size: 12px;
    font-weight: 600;
    color: ${(props) => props.disabled ? props.theme.palette.colors.white : props.theme.palette.colors.black100};
    text-align: center;
    margin: 0 auto;
  }
`;

const STitle = styled.div`
  && {
    font-weight: 500;
    font-size: 10px;
    line-height: 18px;
    margin-top: 5px;
    color: ${({ theme }) => theme.palette.colors.blue100};
  }
`;

const SNote = styled.div`
  && {
    font-size: 13px;
    font-weight: 400;
    color: ${(props) => props.disabled ? props.theme.palette.colors.white : props.theme.palette.colors.black100};
    display: flex;
    align-items: center;
  }
`;

const SInfo = styled.div`
  && {
    display: flex;
    flex-direction: column;
    font-size: 13px;
    font-weight: 600;
    background-color: inherit;
    color: ${(props) =>
      !props.isSelected
        ? props.theme.palette.colors.white
        : props.theme.palette.colors.black};
    width: 100%;
    svg {
      font-size: 20px;
    }
  }
`;

const SContainer = styled('div')`
  && {
    min-height: 100%;
    height: fit-content;
    width: 100%;
    padding: ${({ isSelected }) =>
      isSelected
        ? '1px 8px 6px 6px' // discount border width
        : '3px 10px 8px 8px'};
    margin: 0;
    box-sizing: border-box;
    border-radius: 6px;
    background-color: ${({ backgroundColor }) => backgroundColor};
    border: ${({ isSelected, borderColor }) =>
      isSelected ? `2px solid ${borderColor}` : 'none'};
  }
`;

const SAbsence = styled('div')`
  && {
    background: repeating-linear-gradient(
      135deg,
      ${({ theme }) => theme.palette.colors.blue200},
      ${({ theme }) => theme.palette.colors.blue200} 14px,
      ${({ theme }) => theme.palette.colors.white} 14px,
      ${({ theme }) => theme.palette.colors.white} 28.5px,
      ${({ theme }) => theme.palette.colors.blue200} 28.5px,
      ${({ theme }) => theme.palette.colors.blue200} 42px,
      ${({ theme }) => theme.palette.colors.white} 42px,
      ${({ theme }) => theme.palette.colors.white} 56.5px
    );
    padding: 2px 5px 0 5px;
    border-style: solid;
    border-width: 1px;
    border-radius: 4px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }
`;

const SUserName = styled('div')`
  && {
    width: 100%;
    white-space: nowrap;
    font-weight: 600;
    font-size: 10px;
    line-height: 14px;
    display: flex;
    justify-content: space-between;
    color: ${({ theme }) => theme.palette.colors.black100};
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export { SContainer, STime, STitle, SInfo, SAbsence, SNote, SUserName };
